import LayoutHorizontalSidenav from '@/layout/LayoutHorizontalSidenav'

export default [{
  // Blank layout
  path: '/modules',
  component: LayoutHorizontalSidenav,
  children: [
    {
      path: '',
      name: 'modules',
      component: () => import('@/components/modules/Modules'),
      meta: {
        requiresAuth: true
      }
    }, {
      path: 'new',
      name: 'newModule',
      component: () => import('@/components/modules/EditModule'),
      meta: {
        requiresAuth: true
      }
    }, {
      path: ':id/edit',
      name: 'editModule',
      component: () => import('@/components/modules/EditModule'),
      meta: {
        requiresAuth: true
      },
      props: true
    }
  ]
}]
